import { useQuery } from "@tanstack/react-query";
import api from "../axios-client";

export interface LogFilters {
    category?: string;
    action?: string;
    resourceType?: string;
    resourceId?: string;
    actorId?: string;
    search?: string;
    from?: string;
    to?: string;
    page?: number;
    pageSize?: number;
}

export interface ActivityLog {
    id: string;
    category: string;
    action: string;
    resourceType: string | null;
    resourceId: string | null;
    resourceName: string | null;
    actorId: string | null;
    actorName: string | null;
    businessId: number | null;
    message: string;
    beforeData: Record<string, any> | null;
    afterData: Record<string, any> | null;
    metadata: Record<string, any> | null;
    createdAt: string;
}

export interface LogsResponse {
    logs: ActivityLog[];
    pagination: {
        page: number;
        pageSize: number;
        total: number;
        totalPages: number;
    };
}

export const useGetLogs = (filters: LogFilters = {}) => {
    const params = new URLSearchParams();

    if (filters.category) params.set("category", filters.category);
    if (filters.action) params.set("action", filters.action);
    if (filters.resourceType) params.set("resourceType", filters.resourceType);
    if (filters.resourceId) params.set("resourceId", filters.resourceId);
    if (filters.actorId) params.set("actorId", filters.actorId);
    if (filters.search) params.set("search", filters.search);
    if (filters.from) params.set("from", filters.from);
    if (filters.to) params.set("to", filters.to);
    if (filters.page) params.set("page", String(filters.page));
    if (filters.pageSize) params.set("pageSize", String(filters.pageSize));

    const queryString = params.toString();

    return useQuery<LogsResponse>({
        queryKey: ["logs", filters],
        queryFn: async () => {
            const response = await api.get(`/api/v1/logs${queryString ? `?${queryString}` : ""}`);
            return response.data.data;
        },
        retry: false,
        staleTime: 1000 * 30,
    });
};
